import React, { useState } from 'react';
import { EditWithIcon, NoYet } from 'components';
import { Images, useModal } from 'utils';
import { useMentionOptions } from '../formDetail/formBody/elements/useMentionOptions';
import { useFormBuilder } from '../formDetail';

const DataFieldsModal = ({ currentModelEnums }) => {
    const [searchTerm, setSearchTerm] = useState('');

    const filteredItems = currentModelEnums?.filter((item) => {
        if (!searchTerm) return true;
        const searchLower = searchTerm.toLowerCase();
        return item?.name?.toLowerCase().includes(searchLower) || item?.token?.toLowerCase().includes(searchLower);
    });

    return (
        <div style={{ width: 500 }}>
            <div className="flex-align-center" style={{ gap: 12 }}>
                <EditWithIcon id={'download-form'} icon={Images.database} type={'button'} />
                <p className="modal-header-title">Available Data Fields</p>
            </div>
            <div style={{ height: 1, background: '#DFE1E6', width: '100%', margin: '20px 0' }} />

            <div>
                <div className="data-field-search-box">
                    <img src={Images.search} alt="" />
                    <input type="text" placeholder="Search fields..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                </div>

                <div className="data-field-wrapper">
                    {filteredItems?.length ? (
                        filteredItems?.map((item, index) => (
                            <div key={index} className="data-field-box">
                                <div>{item?.token}</div>
                                <p>{item?.name}</p>
                            </div>
                        ))
                    ) : (
                        <div>
                            <NoYet text="No Available Data Fields" />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export const DataFields = ({}) => {
    const { open } = useModal();
    const { activeSection } = useFormBuilder();
    const noMentions = false;
    const currentModelEnums = useMentionOptions({ noMentions, activeSection });

    return (
        <div>
            <EditWithIcon
                id={'download-form'}
                icon={Images.database}
                type={'button'}
                handleClick={() => {
                    open(<DataFieldsModal currentModelEnums={currentModelEnums} />);
                }}
            />
        </div>
    );
};
